import Swiper from 'swiper';

export default new class EventListSlider {
  constructor() {
    this.sliderContainerSelector = 'eventlist-slider';
    this.slideSelector = 'eventlist-slider__item';
    this.paginationSelector = 'slider__pagination';
    this.nextBulletSelector = 'slider__bullet';
    this.nextBulletActiveSelector = 'slider__bullet_active';
    this.activeSlideSelector = 'slider__item_active';
    this.uselessPaginationSelector = 'slider__pagination-hidden';

    this.handler();
  }

  handler() {
    const slider = document.querySelector(`.${this.sliderContainerSelector}`);

    if (!slider) return;

    document.addEventListener('DOMContentLoaded', () => {
      this.init();
    });
  }

  init() {
    this.EventListSlider = new Swiper(`.${this.sliderContainerSelector}`, {
      slidesPerView: 'auto',
      slidesPerGroup: 1,
      spaceBetween: 16,
      watchOverflow: true,
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
      observer: true,
      speed: 2000,
      autoplay: {
        delay: 5000,
        pauseOnMouseEnter: true,
        stopOnLastSlide: true,
      },
      breakpoints: {
        640: {
          slidesPerGroup: 2,
          spaceBetween: 32,
          pagination: {
            el: `.${this.paginationSelector}`,
            type: 'bullets',
            bulletActiveClass: this.nextBulletActiveSelector,
            bulletClass: this.nextBulletSelector,
            lockClass: this.uselessPaginationSelector,
            clickable: true,
          },
        },
        1024: {
          slidesPerGroup: 3,
          spaceBetween: 32,
          pagination: {
            el: `.${this.paginationSelector}`,
            type: 'bullets',
            bulletActiveClass: this.nextBulletActiveSelector,
            bulletClass: this.nextBulletSelector,
            lockClass: this.uselessPaginationSelector,
            clickable: true,
          },
        },
        1200: {
          slidesPerGroup: 4,
          spaceBetween: 32,
          pagination: {
            el: `.${this.paginationSelector}`,
            type: 'bullets',
            bulletActiveClass: this.nextBulletActiveSelector,
            bulletClass: this.nextBulletSelector,
            lockClass: this.uselessPaginationSelector,
            clickable: true,
          },
        }
      },
    });
    $(window).on("load resize", function () {
      var maxHeight = 0;
      $(".eventlist-slider").find(".eventlist-slider__time").height("auto").each(function () {
        if ($(this).height() > maxHeight) {
          maxHeight = $(this).height();
        }
      }).height(maxHeight);
    });
  }
}();
